import React from 'react';
import styles from './ControlsTabContent.module.scss';
import { passThroughTranslation } from '@colonist/i18n';
import { SegmentedControl, T } from '@colonist/ui';
const ShortcutItem = ({ title, value })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.shortcutItem
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.shortcutLabel
    }, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.controlKeys
    }, value.map((key, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.controlKey
        }, /*#__PURE__*/ React.createElement(T, {
            id: key
        })), index < value.length - 1 && /*#__PURE__*/ React.createElement("div", {
            className: styles.separator
        }, "/")))));
const GAME_SHORTCUTS = [
    {
        title: {
            key: 'strings:game.settings.controlsTab.rollDice'
        },
        value: [
            {
                key: 'strings:game.settings.controlsTab.spacebar'
            }
        ]
    },
    {
        title: {
            key: 'strings:game.settings.controlsTab.endTurn'
        },
        value: [
            {
                key: 'strings:game.settings.controlsTab.spacebar'
            }
        ]
    },
    {
        title: {
            key: 'strings:game.settings.controlsTab.pauseGame'
        },
        value: [
            passThroughTranslation('P')
        ]
    },
    {
        title: {
            key: 'strings:game.settings.controlsTab.fullScreen'
        },
        value: [
            passThroughTranslation('F')
        ]
    }
];
const AUDIO_SHORTCUTS = [
    {
        title: {
            key: 'strings:game.settings.controlsTab.mute'
        },
        value: [
            passThroughTranslation('M')
        ]
    },
    {
        title: {
            key: 'strings:game.settings.controlsTab.volume'
        },
        value: [
            passThroughTranslation('▲'),
            passThroughTranslation('▼')
        ]
    }
];
export const ControlsTabContent = ({ keyboardShortcutsEnabled, onKeyboardShortcutsChange })=>{
    const activeId = keyboardShortcutsEnabled ? 'true' : 'false';
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.controlsTabContentContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.controlsGroupContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.keyboardShortcutsSetting
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.keyboardShortcutsLabel
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.controlsTab.keyboardShortcuts.title'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.segmentedControlInlineWrapper
    }, /*#__PURE__*/ React.createElement(SegmentedControl, {
        options: [
            {
                id: 'false',
                label: {
                    key: 'strings:game.settings.controlsTab.keyboardShortcuts.options.Off'
                }
            },
            {
                id: 'true',
                label: {
                    key: 'strings:game.settings.controlsTab.keyboardShortcuts.options.On'
                }
            }
        ],
        activeId: activeId,
        onTabChange: (id)=>onKeyboardShortcutsChange(id == 'true'),
        size: "lg"
    })))), /*#__PURE__*/ React.createElement("div", {
        className: styles.controlsGroupContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.shortcutGroup
    }, GAME_SHORTCUTS.map((shortcut)=>/*#__PURE__*/ React.createElement(ShortcutItem, {
            key: shortcut.title.key,
            ...shortcut
        }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.shortcutGroup
    }, AUDIO_SHORTCUTS.map((shortcut)=>/*#__PURE__*/ React.createElement(ShortcutItem, {
            key: shortcut.title.key,
            ...shortcut
        })))));
};
